import React from 'react';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';

import { IconButton } from '@material-ui/core';
import { Fullscreen, FullscreenExit } from '@material-ui/icons';

import { CardFull } from '../components';
import * as S from '../styles';

export default function EstoquePostoMonitorFullscreen() {
  const handle = useFullScreenHandle();
  const modalContainer = React.useCallback(
    () => handle.node.current,
    [handle.node]
  );

  return (
    <FullScreen handle={handle}>
      <S.WrapperFullScreen>
        <S.Header>
          <IconButton
            aria-label={
              handle.active
                ? 'Fechar janela em tela cheia'
                : 'Abrir janela em tela cheia'
            }
            onClick={() => (handle.active ? handle.exit() : handle.enter())}
          >
            {handle.active ? <FullscreenExit /> : <Fullscreen />}
          </IconButton>
        </S.Header>
        <CardFull modalContainer={modalContainer} />
      </S.WrapperFullScreen>
    </FullScreen>
  );
}
